import React from "react";
import { connect } from "react-redux";

import { getUserLocation } from "../../redux/auth";
import { PageContent } from "../../components";
import { FinancialsTable } from "../../tables";
import {
  FinancialPeriodDialog,
  DeleteFinancialPeriodDialog,
} from "../../dialogs";

import FinancialsBar from "./FinancialsBar";

const FinancialsContainer = ({ defaultLocation = 1 }) => (
  <PageContent gap="10px" smallPadding hideOverflow>
    <FinancialsBar />
    <FinancialsTable defaultLocation={defaultLocation} />
    <FinancialPeriodDialog />
    <DeleteFinancialPeriodDialog />
  </PageContent>
);

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});

export const FinancialsContainerConnected = connect(mapStateToProps)(
  FinancialsContainer,
);
export default FinancialsContainerConnected;
